import { tvpil } from '../../compat/tvpil';
import { getFavoriteChannels } from '../../favorite';
import { getLastWatched } from '../../lastWatched';
import { getMostWatched } from '../../mostWatched';
import { getPersonalLineup } from '../../personalLineup';

import { ChannelsPersonalization } from './types';

type GetChannelsPersonalization = {
  referenceId: string;
  pageReferenceId?: string;
};

export function getChannelsPersonalization({
  referenceId,
  pageReferenceId,
}: GetChannelsPersonalization): ChannelsPersonalization | undefined {
  const isPersonalLineupEnabled = tvpil.rootStore.isPersonalLineupEnabled;
  const isFavoriteChannelPersonalization = tvpil.rootStore.isFavoriteChannelPersonalization;

  const mostWatched = getMostWatched({ referenceId });
  const lastWatched = pageReferenceId ? getLastWatched({ referenceId, pageReferenceId }) : undefined;
  const favoriteChannels = getFavoriteChannels();
  const personalLineup = getPersonalLineup();

  if (isPersonalLineupEnabled) {
    return {
      lastWatched,
      personalLineup,
    };
  }

  if (isFavoriteChannelPersonalization) {
    return {
      favoriteChannels,
      lastWatched,
      mostWatched,
    };
  }

  return {
    lastWatched,
  };
}
